import { Tooltip } from 'antd';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getSize, StyledHeadTitle, styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var pageHeaderHeight = 80;
var FormDescription = styled.label.withConfig({
  displayName: "form-page-header-previewcontainer__FormDescription",
  componentId: "sc-1meq6dd-0"
})(["font-size:14px;line-height:20px;color:", ";display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], styleVariables.colors.gray11);
var StyledPageHeaderWrapper = styled.div.withConfig({
  displayName: "form-page-header-previewcontainer__StyledPageHeaderWrapper",
  componentId: "sc-1meq6dd-1"
})(["background:transparent;margin-bottom:", ";"], getSize('padding24'));
var StyledContentHeader = styled.div.withConfig({
  displayName: "form-page-header-previewcontainer__StyledContentHeader",
  componentId: "sc-1meq6dd-2"
})(["display:flex;align-items:center;color:#64748b;font-size:14px;font-weight:500;b{font-weight:700;color:#1e293b;}"]);
export var FormPreviewHeaderContainer = function FormPreviewHeaderContainer() {
  // Get data from selector
  var form = useSelector(function (state) {
    var _state$formPreviewApp;

    return (_state$formPreviewApp = state.formPreviewApp) === null || _state$formPreviewApp === void 0 ? void 0 : _state$formPreviewApp.form;
  });
  return /*#__PURE__*/_jsxs(StyledPageHeaderWrapper, {
    children: [/*#__PURE__*/_jsx(StyledHeadTitle, {
      style: {
        margin: 0
      },
      children: form === null || form === void 0 ? void 0 : form.title
    }), /*#__PURE__*/_jsx(StyledContentHeader, {
      children: (form === null || form === void 0 ? void 0 : form.description) && /*#__PURE__*/_jsx(Tooltip, {
        title: form.description,
        placement: "top",
        children: /*#__PURE__*/_jsx(FormDescription, {
          children: form.description
        })
      })
    })]
  });
};